<script>
/**
 * @overview 图片上传压缩
 *
 * @author suyanping
 */
import initCos from '../../utils/upload/tencentCos';
import store from '../../store/index';

export default {
  name: 'AppUploadScale',

  props: {
    // 是否为手机页
    isH5: {
      type: Boolean,
      default: false,
    },
    // 双向绑定值
    value: {
      type: String,
      default: '',
    },
    // 是否为公共资源
    common: {
      type: Boolean,
      default: false,
    },
    // 提交回调信息
    type: {
      type: String,
      default: '',
    },
    // 显示加号
    icon: {
      type: Boolean,
      default: false,
    },
    // 显示按钮或者图片
    isButton: {
      type: Boolean,
      default: false,
    },
    // 上传按钮的text
    btnText: {
      type: String,
      default: '',
    },
  },

  data() {
    return {

    };
  },

  computed: {
    style() {
      return this.value ? '' : { border: '1px solid gainsboro' };
    },
  },

  methods: {
    uploadImg() {
      this.$refs.inputImg.click();
    },

    changeImg() {
      const inputs = this.$refs.inputImg;

      const file = inputs.files[0];
      console.log(file);
      const pattern = /^image\/(jpe?g|png|bmp|JPE?G|PNG|BMP)$/;
      const isPicture = pattern.test(file.type);

      const isLimit2M = file.size / 1024 / 1024 <= 5;

      if (!isPicture) {
        this.$message({
          message: '上传图片只能是 JPG、PNG、BMP 格式!!',
          type: 'error',
          customClass: this.isH5 ? 'auth_dialog_box_message' : '',
        });

        inputs.value = '';

        return;
      }

      if (isLimit2M) {
        this.getImgData(file);

        inputs.value = '';

        return;
      }

      this.getScalePhoto(file, { quality: 0.5 }, (base64Codes) => {
        const newFile = this.convertBase64UrlToFile(base64Codes, file.name);

        const isAgainLimit2M = newFile.size / 1024 / 1024 <= 2;

        if (!isAgainLimit2M) {
          this.$message({
            message: '上传图片大小过大!',
            type: 'error',
            customClass: this.isH5 ? 'auth_dialog_box_message' : '',
          });

          return;
        }

        this.getImgData(newFile);
      });

      inputs.value = '';
    },

    getScalePhoto(file, percentage, objDiv) {
      const that = this;
      const ready = new FileReader();

      ready.readAsDataURL(file);

      // eslint-disable-next-line
      ready.onload = function () {
        const result = this.result;
        that.canvasDataURL(file.type, result, percentage, objDiv);
      };
    },

    canvasDataURL(type, path, obj, callback) {
      const img = new Image();
      const imgType = type || 'image/jpeg';
      img.src = path;
      // eslint-disable-next-line
      img.onload = function () {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        // 瓦片canvas
        const tCanvas = document.createElement('canvas');
        const tctx = tCanvas.getContext('2d');
        const initSize = img.src.length;
        let width = img.width;
        let height = img.height;
        // 如果图片大于四百万像素，计算压缩比并将大小压至400万以下
        let ratio;
        if ((ratio = (width * height) / 4000000) > 1) {
          console.log('大于400万像素');
          ratio = Math.sqrt(ratio);
          width /= ratio;
          height /= ratio;
        } else {
          ratio = 1;
        }
        canvas.width = width;
        canvas.height = height;
        //        铺底色
        ctx.fillStyle = '#fff';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        // 如果图片像素大于100万则使用瓦片绘制
        let count;
        if ((count = (width * height) / 1000000) > 1) {
          console.log('超过100W像素');
          count = ~~(Math.sqrt(count) + 1); // 计算要分成多少块瓦片
          //            计算每块瓦片的宽和高
          const nw = ~~(width / count);
          const nh = ~~(height / count);
          tCanvas.width = nw;
          tCanvas.height = nh;
          for (let i = 0; i < count; i++) {
            for (let j = 0; j < count; j++) {
              tctx.drawImage(
                img,
                i * nw * ratio,
                j * nh * ratio,
                nw * ratio,
                nh * ratio,
                0,
                0,
                nw,
                nh,
              );
              ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
            }
          }
        } else {
          ctx.drawImage(img, 0, 0, width, height);
        }
        // 进行最小压缩
        const ndata = canvas.toDataURL(imgType, obj);
        console.log(`压缩前：${initSize}`);
        console.log(`压缩后：${ndata.length}`);
        console.log(
          `压缩率：${~~((100 * (initSize - ndata.length)) / initSize)}%`,
        );
        tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
        // 回调函数返回base64的值
        callback(ndata);
      };
    },

    convertBase64UrlToFile(urlData, filename) {
      // eslint-disable-next-line
      let arr = urlData.split(','), mime = arr[0].match(/:(.*?);/)[1],bstr = atob(arr[1]),n = bstr.length,u8arr = new Uint8Array(n);

      // eslint-disable-next-line
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mime });
    },
    getImgData(file) {
      const that = this;
      initCos(file, this.common ? 0 : store.state.choicesSchool ? store.state.choicesSchool.id : 0, (res) => {
        const cos = res.cos;
        const _key = `${res.resource_dir}${res.md5}.${res.type}`;

        cos.putObject({
          Bucket: res.Bucket, /* 必须 */
          Region: res.Region, /* 存储桶所在地域，必须字段 */
          Key: _key, /* 必须 */
          StorageClass: 'STANDARD',
          Body: file, // 上传文件对象
          onProgress(progressData) {
            console.log('onProgress', JSON.stringify(progressData));
          },
        }, (err, data) => {
          if (data) {
            that.$emit('on-success', `https://${data.Location}`, `${res.name}.${res.type}`, that.type);
            that.icon = false;
          } else {
            that.$message.error(err);
          }
        });
      });
    },
  },
};
</script>

<template>
  <div class="app-upload-scale">
    <input
      ref="inputImg"
      type="file"
      accept="image/jpg,image/jpeg,image/png,image/bmp"
      style="display:none;"
      @change="changeImg">

    <el-button
      v-if="isButton"
      size="small"
      @click="uploadImg">
      {{ btnText }}
    </el-button>

    <div
      v-else
      :style="style"
      class="app-upload-scale__block"
      @click="uploadImg">
      <i
        v-if="icon && !value"
        class="icon el-icon-plus"/>
      <!-- <img
        v-if="value"
        :src="value"> -->
      <el-image
        v-if="value"
        :src="value"
        fit="fill"
        style="width: 100%; height: 100%"/>
    </div>
  </div>
</template>

<style lang="postcss" scoped>
.app-upload-scale{
  display: inline-block;
}
.app-upload-scale__block {
  cursor: pointer;
  width: 100%;
  height: 100%;
  min-height: 100px;
}
.app-upload-scale__block .icon {
  display: block;
  margin: 0 auto;
  width: 100px;
  height: 100px;
  font-size: 80px;
  text-align: center;
  line-height: 100px;
  color: gainsboro;
  position: relative;
  top: calc(50% - 50px);
}
.app-upload-scale__block img {
  width: 100%;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/AppUploadScale/index.vue